import { useContext, useEffect, useRef } from "react";

import { Dialog } from "primereact/dialog";

import { setScormPassed } from "sj-ui-toolkit/src/utils/rxd";

import { VideoContext } from "../../VideoContext";

import FeedbackPage from "../../../../Feedback/FeedbackPage";

import QuizQuestions from "./QuizQuestions";
import QuizReview from "./QuizReview";
import QuizSkeleton from "./QuizSkeleton";

import S from "./_styles.module.scss";

export default function QuizContent() {
  const { quiz, questionsLoading, feedbackModalVisible, closeFeedbackModal, currentQuestionId } =
    useContext(VideoContext);
  const prevResultRef = useRef(quiz?.assessment.result);
  const feedbackDetailsRef = useRef<HTMLTextAreaElement>(null);
  const isQuizComplete = quiz?.assessment.answersCount === quiz?.assessment.questionsCount;

  // Call setScormPassed when quiz result changes to "passed"
  useEffect(() => {
    const currentResult = quiz?.assessment.result;
    const previousResult = prevResultRef.current;

    if (previousResult === "in_progress" && currentResult === "passed") {
      setScormPassed({
        score: quiz?.assessment.assessmentScore ?? 0,
        max: 100,
        min: 0,
      });
    }

    prevResultRef.current = currentResult;
  }, [quiz?.assessment.result, quiz?.assessment.assessmentScore]);

  if (!quiz || questionsLoading) {
    return <QuizSkeleton />;
  }

  return (
    <div className={S.quizContainer}>
      {isQuizComplete ? <QuizReview /> : <QuizQuestions />}
      <Dialog
        header="Feedback"
        visible={feedbackModalVisible}
        onHide={closeFeedbackModal}
        onShow={() => feedbackDetailsRef.current?.focus()}
        style={{ width: "50vw" }}
        breakpoints={{ "960px": "75vw", "641px": "90vw" }}
        ariaCloseIconLabel="Close feedback dialog"
        data-testid="quiz-feedback-dialog"
      >
        <FeedbackPage
          forQuiz={true}
          questionId={currentQuestionId}
          detailsInputRef={feedbackDetailsRef}
        />
      </Dialog>
    </div>
  );
}
